export default "__VITE_ASSET__Bf5VAkd6__"